import { useIsMobile } from "../../store/user";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import "../../i18n/i18n";
import data from "../../data/data.json";

const DictionaryActiveModal = () => {
  const isMobile = useIsMobile();
  const [translations, setTranslations] = useState([]);
  const { t, i18n } = useTranslation();

  const changeLang = async (language) => {
    i18n.changeLanguage(language);
  };

  useEffect(() => {
    changeLang("en");
  }, []);

  return (
    <>
      <div
        className={`${
          isMobile ? "bottom-[5.5rem] px-[1rem]" : "bottom-[2.19rem]"
        } fixed w-full flex justify-center items-center z-10`}
      >
        <div
          className={`${
            isMobile ? "w-[25rem]" : "w-[29.125rem]"
          } rounded-[1.188rem]  relative flex`}
        >
          <div
            className={`${
              isMobile ? "p-[1.2rem]" : "p-[0.64rem]"
            } z-50 rounded-[7rem]  border-4 border-[#1F6EAF] bg-white shadow-[0px_0px_4px_3px_rgba(0,0,0,0.10)]`}
          >
            <div
              style={{
                backgroundImage: `url(${"/dictionary/dictionay_icon.svg"})`,
              }}
              className="w-[2.625rem] h-[2.625rem] flex-shrink-0 aspect-square bg-no-repeat bg-center bg-contain"
              alt="dictionary"
            />
          </div>
          <div
            className={`${
              isMobile ? "left-[2.5rem]" : "left-[2rem]"
            } h-full flex items-center absolute py-[0.19rem] z-30`}
          >
            <div
              className={`${
                isMobile
                  ? "pl-[3.25rem] pr-[2rem]"
                  : "pl-[5.90625rem] pr-[3.90625rem]"
              } py-[1.0625rem]  rounded-[0.5rem] border-[0.188rem] border-[#35529D] bg-white`}
            >
              <div
                className={`${
                  isMobile ? "text-primary" : "text-secondary text-nowrap "
                } text-widget-background font-secondary  leading-[1.375rem]`}
              >
                {t(data.keyTabs[0].title)}
              </div>
            </div>
          </div>
        </div>
        <button
          onClick={() => {
            changeLang("gr");
          }}
        >
          change lang as gr
        </button>
        <br />
        <button
          onClick={() => {
            changeLang("en");
          }}
        >
          change lang as en
        </button>
      </div>
    </>
  );
};

export default DictionaryActiveModal;

